import { setup } from 'bem-cn';

const block = setup({
  el: '__',
  mod: '--',
  modValue: '-',
});

/**
 * Creates a BEM block function that returns string classNames
 * This wrapper ensures compatibility with styled-components v6 which
 * requires string classNames for proper merging
 */
export const bemClassName = (blockName) => {
  const b = block(blockName);

  // Return a function that converts bem-cn results to strings
  return (...args) => b(...args).toString();
};
